import { render, staticRenderFns } from "./Reporte-ventas-app.vue?vue&type=template&id=56fb2a3d&scoped=true&"
import script from "./Reporte-ventas-app.vue?vue&type=script&lang=js&"
export * from "./Reporte-ventas-app.vue?vue&type=script&lang=js&"
import style0 from "./Reporte-ventas-app.vue?vue&type=style&index=0&id=56fb2a3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fb2a3d",
  null
  
)

export default component.exports